/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import _ from "underscore";
import Schema from "../Schema";
import resources from "../schemas";
import UiSchema from "../UiSchema";

/**
 * Static class for retrieving schema information about the resource
 */
class SchemaRegistry {
    /**
     * Return navigation schema for specified resource
     * @param {string} resource Resource name
     * @returns {UiSchema}
     */
    static getNavigationSchemaObject(resource) {
        let uiSchema = SchemaRegistry.getUiSchema(resource, "nav");
        return new UiSchema(uiSchema);
    }

    /**
     * Returns Schema object for retrieving information about current resource schema.
     * @param {?string} parentResource Parent resource name
     * @param {?string} resource Current resource name
     * @param {string} name Schema name
     * @returns {Schema} Schema object
     */
    static getSchemaObject(parentResource, resource, name) {
        if (!parentResource) parentResource = resource;
        else if (!resource) resource = parentResource;

        let uiSchema = SchemaRegistry.getUiSchema(parentResource, name);
        if (uiSchema && uiSchema["ui:resource"]) resource = uiSchema["ui:resource"];
        let jsonSchema = SchemaRegistry.getJsonSchema(resource, name);
        return new Schema(jsonSchema, uiSchema, resource);
    }

    /**
     * Returns Schema object for retrieving information about current resource schema. Returned schema
     * corresponds to the array of resource items.
     * @param name Object name
     * @param type Schema type
     * @returns {Schema} Schema object
     */
    static getSchemaObjectForArray(name, type) {
        let uiSchema = SchemaRegistry.getUiSchema(name, type);
        let resource = name;
        if (uiSchema["ui:resource"]) resource = uiSchema["ui:resource"];
        let jsonSchema = SchemaRegistry.getJsonSchema(resource, "list");
        return new Schema(jsonSchema, uiSchema, resource);
    }

    /**
     * Returns JSON Schema for specified resource
     * @public
     * @param {string} name Resource name
     * @param {('search'|'list'|'view'|'new'|'edit'|'delete')} type JSON Schema type
     * @returns {object} JSON Schema
     */
    static getJsonSchema(name, type = "view") {
        let schema = SchemaRegistry.getSchema(name, "schema");
        if (type === "list" || type === "nav") return Schema.createArrayJsonSchema(schema);
        return schema;
    }

    /**
     * Returns UI Schema for specified resource
     * @public
     * @param {string} name Resource name
     * @param {('search'|'list'|'view'|'new'|'edit'|'delete')} type UI Schema type
     * @returns {object} UI Schema
     */
    static getUiSchema(name, type) {
        return SchemaRegistry.getSchema(name, type);
    }

    /**
     * Internally used for retrieving resource schema
     * @private
     * @param {string} name Resource name
     * @param {string} type Schema type (use "schema" for JSON Schema)
     * @returns {object} Schema object
     */
    static getSchema(name, type) {
        let schema = SchemaRegistry.getSchemaForType(name, type);
        if (!schema) schema = SchemaRegistry.getSchemaForType("default", type);
        return schema;
    }

    static getSchemaForType(name, type) {
        if (!resources[name]) return null;
        if (resources[name][type]) return resources[name][type];
        switch (type) {
            case "new":
                if (resources[name]["edit"]) return resources[name]["edit"];
                // Intentionally no break here!
            case "edit":
                if (resources[name]["view"]) return resources[name]["view"];
                return null;
            default:
                return null;
        }
    }
}

export default SchemaRegistry;
